import Reveal from "./Reveal";

const SectionHeading = ({ chapter, title, subtitle, testid, light = false }) => (
  <div className="mb-12 lg:mb-16 max-w-3xl" data-testid={testid}>
    <Reveal>
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand mb-4">{chapter}</p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className={`font-display font-bold uppercase tracking-tight leading-[0.95] text-3xl sm:text-4xl lg:text-5xl ${light ? "text-ink" : "text-cream"}`}>
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.16}>
        <p className={`mt-5 text-base leading-relaxed ${light ? "text-ink/70" : "text-fog"}`}>{subtitle}</p>
      </Reveal>
    )}
  </div>
);

export default SectionHeading;
